import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "grid w-full bg-white transition-grid-template-rows duration-300" }
const _hoisted_2 = { class: "overflow-hidden" }
const _hoisted_3 = { class: "mt-16 flex flex-col gap-y-12" }
const _hoisted_4 = { class: "z-10 bg-white text-12 font-medium text-black-900" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "text-12 font-medium text-black-900" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_v_image = _resolveComponent("v-image")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.filtersArray, (filter, i) => {
          return (_openBlock(), _createElementBlock("div", {
            key: filter,
            class: "flex snap-x items-center gap-x-8"
          }, [
            _createElementVNode("span", _hoisted_4, _toDisplayString(filter.label), 1),
            _createElementVNode("div", {
              class: _normalizeClass(["hide-scrollbar flex snap-x items-center gap-x-8 overflow-x-scroll", {'bounce-in-right': $props.isOpen}])
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filter.values, (value) => {
                return (_openBlock(), _createElementBlock("button", {
                  key: value,
                  type: "button",
                  class: _normalizeClass(["flex cursor-pointer snap-start items-center gap-x-4 rounded border border-black-200 bg-black-50 px-8 py-2 laptop:hover:border-black-400", {
                'border-black-900 laptop:hover:border-black-900':
                  $options.activeFiltersValue.includes(value),
              }]),
                  onClick: $event => ([$options.toggleFilter(value, filter.label, i), _ctx.$emit('isSelected', $data.activeFilters)])
                }, [
                  _createVNode(_component_v_image, {
                    lazyloaded: "",
                    source: $options.getImageUrl(value),
                    class: "aspect-square h-14 min-w-[.875rem] rounded-full"
                  }, null, 8, ["source"]),
                  _createElementVNode("span", _hoisted_6, _toDisplayString(value), 1)
                ], 10, _hoisted_5))
              }), 128))
            ], 2)
          ]))
        }), 128))
      ])
    ])
  ]))
}